import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe } from "types/generated";

type StackTerragruntMigration = {
  migrated: number;
  readyToMigrate: number;
};

type GetStacksRequiringAttentionData = {
  metrics: Maybe<{
    stacksRequiringAttention: {
      stackTerragruntMigration: Maybe<StackTerragruntMigration>;
    };
  }>;
};

export const GET_STACKS_REQUIRING_ATTENTION: TypedDocumentNode<GetStacksRequiringAttentionData> = gql`
  query GetStacksRequiringAttention {
    metrics {
      stacksRequiringAttention {
        stackTerragruntMigration {
          migrated
          readyToMigrate
        }
      }
    }
  }
`;
